export const styles = {
  // Pulls the header to the edges of the Paper card (Paper has padding: "2em 3em")
  header: {
    backgroundColor: "#1B3A2D",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "-2em -3em 0",
    width: "calc(100% + 6em)",
    padding: "28px 3em 32px",
    borderRadius: "8px 8px 0 0",
    gap: "8px",
    boxSizing: "border-box",
  },
  headerBrand: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  headerLogo: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#4CAF50",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerLogoImg: {
    width: "24px",
    height: "24px",
  },
  headerTitle: {
    color: "#FFFFFF",
    fontSize: "22px",
    fontWeight: "700",
    margin: "0",
    lineHeight: "1.3",
  },
  headerSubtitle: {
    color: "#4CAF50",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "32px 0 8px",
    fontFamily: "Inter, sans-serif",
  },
  warningIconWrapper: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#FFF8F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
  },
  warningIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    border: "2px solid #F57C00",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  warningIconText: {
    color: "#F57C00",
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "1",
  },
  pageTitle: {
    color: "#0D1B2A",
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    margin: "0 0 24px",
    lineHeight: "1.3",
  },
  infoCard: {
    backgroundColor: "#FFFBEB",
    borderRadius: "12px",
    width: "100%",
    overflow: "hidden",
    marginBottom: "32px",
  },
  infoCardBody: {
    padding: "20px 20px 16px",
    color: "#1A2B3C",
    fontSize: "16px",
    lineHeight: "1.6",
    textAlign: "center",
    margin: "0",
  },
  infoCardDivider: {
    height: "1px",
    backgroundColor: "#E8DFC0",
    margin: "0 20px",
  },
  infoCardWarning: {
    padding: "16px 20px 20px",
    color: "#B84A0A",
    fontSize: "15px",
    fontWeight: "600",
    lineHeight: "1.5",
    textAlign: "center",
    margin: "0",
  },
  logoutButton: {
    backgroundColor: "#1B3A2D",
    color: "#4CAF50",
    border: "none",
    borderRadius: "12px",
    padding: "18px 24px",
    fontSize: "17px",
    fontWeight: "700",
    width: "100%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    letterSpacing: "0.01em",
  },
  logoutIconImg: {
    width: "20px",
    height: "20px",
  },
};
